<template>
  <div>
    <b-card :title="$t('settings.district.details')">
      <p>{{ $t('settings.district.details') }} - {{ $route.params.id }}</p>
      <b-button
        variant="outline-secondary"
        @click="$router.go(-1)"
      >
        {{ $t('common.back') }}
      </b-button>

      <!-- Activity Logs Section -->
      <b-row
        v-if="hasPermission('view activity_logs')"
        class="mt-3"
      >
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'district'"
              :model-id="Number($route.params.id)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  components: {
    BCard, BButton, BRow, BCol, ActivityLogs,
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
  },
}
</script>
